export default __webpack_public_path__ + "img/sowl-logo.880e58e.svg";